import {observer} from 'mobx-react-lite'
import React from 'react'
import { MealDealExplorer } from './meal-deal-explorer'
import { MealDealBuilder } from './meal-deal-builder'
import { useSearchParams } from '../../hooks/use-search-params'

const PROMO_QUERY_NAME = 'promo'

const MealDealsContainer: React.FC = () => {
  const searchParams = useSearchParams()
  const promoID: string = searchParams.get(PROMO_QUERY_NAME) || ''

  if (promoID) {
    return (<MealDealBuilder promoID={promoID}/>)
  }

  return (<MealDealExplorer/>)
}

export const MealDeals = observer(MealDealsContainer)
